<template>
  <div class="card">
    <h1
      class="card__title"
      :style="titleStyles">
      {{ title }}
    </h1>
    <p
      class="card__value"
      :style="valueStyles"
      v-html="numberWithSpaces(value)">
    </p>
  </div>
</template>

<script>
import formattable from '@/mixins/formattable.js'

export default {
  mixins: [
    formattable
  ],

  props: {
    title: {
      type: String,
      required: true
    },
    value: {
      type: Number,
      required: true
    },

    titleStyles: {
      type: Object,
      default: () => { return {} }
    },
    valueStyles: {
      type: Object,
      default: () => { return {} }
    }
  }
}
</script>

<style>
.card {
  position: relative;
  z-index: -2;

  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: left;

  box-sizing: border-box;
  /* padding: 1.5rem;
  border-radius: 0.5rem; */
  overflow: hidden;

  animation-name: pulsecard;
  animation-iteration-count: infinite;
  animation-duration: 10s;
  animation-timing-function: linear;
}

.card__title {
  margin: 0;
  /* margin-top: auto; */
  margin-bottom: 10px;
  font-size: 80px;
}

.card__value {
  margin: 0;
  font-size: 160px;
  font-weight: bold;
}
</style>